<div class="row">
  <div class="col-md-12">
    <cap-content-header [disableBreadcrumb]="true">
      <cap-title>
        {{ "configuration.konfigurationDerAnsicht" | translate }}
      </cap-title>
      <cap-title-functionbar>
        <div class="inline-form float-end">
          <div ngbDropdown placement="bottom-right">
            <button class="btn btn-white btn-sm buttonGroup addedButton" ngbDropdownToggle type="button">
              <span aria-hidden="true" class="fas fa-ellipsis-v fa-fw"></span>
            </button>
            <div class="dropdown-menu" ngbDropdownMenu style="margin-right: 10px">
              <div class="file-upload-wrapper ps-2">
                <a [routerLink]="'./file'">{{"configuration.konfigurationVerwalten" | translate}}</a>
              </div>
            </div>
          </div>
        </div>
      </cap-title-functionbar>
    </cap-content-header>

    <cap-link-list [rootMenuElement]="menuElements.UNTERSTUETZUNG" [titleKey]="'configuration.linksImMenuUnterstuetzung'"></cap-link-list>
    <cap-link-list
      [rootMenuElement]="menuElements.UNTERSTUETZUNG_PUBLIC"
      [titleKey]="'configuration.linksImMenuUnterstuetzungPublic'"></cap-link-list>
    <cap-grundstueck-rubrik-config></cap-grundstueck-rubrik-config>
    <cap-pfandrecht-rubrik-config></cap-pfandrecht-rubrik-config>
    <cap-standardrecht-rubrik-config></cap-standardrecht-rubrik-config>
  </div>
</div>
